import React, {useCallback, useState} from 'react';
import styles from './ProgramDescription.module.scss';
import CloseIcon from 'src/assets/icons/close.svg?react';
import Button from 'src/components/button/Button';
import { SllProgram } from '@src/api/graphql-codegen';

type Props = {
  program: SllProgram;
};

function ProgramPurpleBanner(props: Props) {
  const { program } = props
  const [isVisible, setIsVisible] = useState(true);

  const handleOpenMore = () => {
    window.open(program?.learnMoreDesc ?? '/', '_blank');
  }

  const handleHiddenDescription = useCallback(async () => {
    setIsVisible(false);
  }, [])

  const text = program?.bannerDesc;
  const boldText = text?.replace(program.name, `<strong>${program.name}</strong>`);

  if (!isVisible) return <></>

  return (
    <div className={styles.programDescription}>
      <div className={styles.content}>
        <div className={styles.bannerText} dangerouslySetInnerHTML={{ __html: boldText ?? "" }} />
        <div>
          {program?.learnMoreDesc && <Button size='small' outline={true} className={styles.learnMoreButton} label='LEARN MORE' onClick={handleOpenMore}/>}
        </div>
      </div>
      <CloseIcon className={styles.closeIcon} onClick={handleHiddenDescription} />
    </div>
  );
}

export default ProgramPurpleBanner;
